// import { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock,
//   FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp,
//   FaPaperPlane, FaChevronRight,
// } from "react-icons/fa";
// import { siteConfig } from "../data/siteConfig";
// import "../styles/Footer.css";

// const quickLinks = [
//   { to: "/", label: "Home" },
//   { to: "/about", label: "About Us" },
//   { to: "/rooms", label: "Rooms & Suites" },
//   { to: "/amenities", label: "Amenities" },
//   { to: "/gallery", label: "Gallery" },
//   { to: "/contact", label: "Contact Us" },
// ];

// const Footer = () => {
//   const [email, setEmail] = useState("");
//   const [subscribed, setSubscribed] = useState(false);

//   const handleSubscribe = (e) => {
//     e.preventDefault();
//     setSubscribed(true);
//     setEmail("");
//   };

//   return (
//     <footer className="footer">
//       <div className="container">
//         <div className="footer-grid">
//           {/* About */}
//           <div className="footer-about">
//             <Link to="/" className="logo">
//               <span className="logo-badge">U</span>
//               <span className="logo-text">
//                 <strong>USHA <span>RESORT</span></strong>
//                 <small>Patna · Bihar</small>
//               </span>
//             </Link>
//             <p>
//               A serene luxury escape in the heart of Patna — elegant rooms, a sparkling pool,
//               lush lawns and grand banquet spaces for every celebration.
//             </p>
//             <div className="footer-social">
//               <a href={siteConfig.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
//               <a href={siteConfig.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
//               <a href={siteConfig.social.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"><FaYoutube /></a>
//               <a href={`https://wa.me/${siteConfig.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
//             </div>
//           </div>

//           {/* Quick links */}
//           <div>
//             <h4>Quick Links</h4>
//             <ul className="footer-links">
//               {quickLinks.map((l) => (
//                 <li key={l.to}>
//                   <Link to={l.to}><FaChevronRight /> {l.label}</Link>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           {/* Contact */}
//           <div>
//             <h4>Contact Info</h4>
//             <ul className="footer-contact">
//               <li><FaMapMarkerAlt /> <span>{siteConfig.address}</span></li>
//               <li><FaPhoneAlt /> <a href={siteConfig.phoneHref}>{siteConfig.phone}</a></li>
//               <li><FaEnvelope /> <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a></li>
//               <li><FaClock /> <span>{siteConfig.hours}</span></li>
//             </ul>
//           </div>

//           {/* Newsletter */}
//           <div>
//             <h4>Newsletter</h4>
//             <p style={{ fontSize: ".9rem", marginBottom: 18 }}>Subscribe to get updates on offers & events.</p>
//             <form className="footer-news" onSubmit={handleSubscribe}>
//               <input
//                 type="email"
//                 placeholder="Your email address"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//               />
//               <button type="submit" aria-label="Subscribe"><FaPaperPlane /></button>
//             </form>
//             {subscribed && <p className="footer-note">✅ Thanks for subscribing!</p>}
//           </div>
//         </div>
//       </div>

//       <div className="footer-bottom">
//         <div className="container">
//           © {new Date().getFullYear()} <span>USHA Resort, Patna</span>. All Rights Reserved.
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock,
  FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp,
  FaPaperPlane, FaChevronRight,
} from "react-icons/fa";
import { siteConfig } from "../data/siteConfig";
import "../styles/Footer.css";

const quickLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/rooms", label: "Rooms & Suites" },
  { to: "/lawns", label: "Lawns & Venues" },
  { to: "/banquet", label: "Banquet Halls" }, 
  { to: "/amenities", label: "Amenities" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact Us" },
];

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [logoError, setLogoError] = useState(false); // 👈 PNG fallback state

  // Show PNG logo if available, otherwise fall back to "U" letter badge
  const showLogoImage = siteConfig.logo && !logoError;

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">

          {/* ---------- About + Logo ---------- */}
          <div className="footer-about">
            <Link to="/" className="logo" aria-label="USHA Resort — Home">
              {showLogoImage ? (
                <img
                  src={siteConfig.logo}
                  alt="USHA Resort Logo"
                  className="footer-logo-img"
                  onError={() => setLogoError(true)} // 👈 auto-fallback to "U" badge
                />
              ) : (
                <span className="logo-badge">U</span>
              )}

              {/* Hide text if logo PNG already contains the resort name */}
              {siteConfig.logoText !== false && (
                <span className="logo-text">
                  {/* <strong>USHA <span>RESORT</span></strong>
                  <small>Patna · Bihar</small> */}
                </span>
              )}
            </Link>

            <p>
              A serene luxury escape in the heart of Patna — elegant rooms, a sparkling pool,
              lush lawns and grand banquet spaces for every celebration.
            </p>

            <div className="footer-social">
              <a href={siteConfig.social.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href={siteConfig.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href={siteConfig.social.youtube} target="_blank" rel="noreferrer" aria-label="YouTube"><FaYoutube /></a>
              <a href={`https://wa.me/${siteConfig.whatsapp}`} target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>

          {/* ---------- Quick Links ---------- */}
          <div>
            <h4>Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to}><FaChevronRight /> {l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* ---------- Contact Info ---------- */}
          <div>
            <h4>Contact Info</h4>
            <ul className="footer-contact">
              <li><FaMapMarkerAlt /> <span>{siteConfig.address}</span></li>
              <li><FaPhoneAlt /> <a href={siteConfig.phoneHref}>{siteConfig.phone}</a></li>
              <li><FaEnvelope /> <a href={`mailto:${siteConfig.email}`}>{siteConfig.email}</a></li>
              <li><FaClock /> <span>{siteConfig.hours}</span></li>
            </ul>
          </div>

          {/* ---------- Newsletter ---------- */}
          <div>
            <h4>Newsletter</h4>
            <p style={{ fontSize: ".9rem", marginBottom: 18 }}>
              Subscribe to get updates on offers & events.
            </p>
            <form className="footer-news" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" aria-label="Subscribe"><FaPaperPlane /></button>
            </form>
            {subscribed && <p className="footer-note">✅ Thanks for subscribing!</p>}
          </div>

        </div>
      </div>

      {/* ---------- Bottom Bar ---------- */}
      <div className="footer-bottom">
        <div className="container">
          © {new Date().getFullYear()} <span>USHA Resort, Patna</span>. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;